import LoadingIndicator from '@/widgets/LoadingIndicator'
import NoResultsIndicator from '@/widgets/NoResultsIndicator'
import InvoicesTableRow from './InvoicesTableRow'
import { getSortIndicator } from '@/lib/tableHelpers'
import { useTranslation } from 'react-i18next'

export default function InvoicesTable({
	invoicesData,
	loading,
	selectedInvoices,
	onSelectAll,
	onSelectInvoice,
	isAllSelected,
	isIndeterminate,
	sortColumn,
	sortDirection,
	onSort,
	systemSettings,
	onAssignPlacowka,
}) {
	const { t } = useTranslation()
	const columns = [
		{ key: 'number', label: t('invoices.list.table.invoiceNumber'), sortable: true },
		{ key: 'companyName', label: t('invoices.list.table.company'), sortable: true },
		{ key: 'infakt_client_company_name', label: t('invoices.list.table.infaktClientCompanyName'), sortable: true },
		{ key: 'customerName', label: t('invoices.list.table.placowka'), sortable: true },
		{ key: 'invoiceDate', label: t('invoices.list.table.invoiceDate'), sortable: true },
		{ key: 'invoiceStatus', label: t('invoices.list.table.status'), sortable: false },
		{ key: 'total', label: t('invoices.list.table.total'), sortable: true },
	]

	if (loading) return <LoadingIndicator />
	if (!invoicesData || invoicesData.length === 0) {
		return (
			<NoResultsIndicator
				message={t('invoices.list.emptyState.title')}
				description={t('invoices.list.emptyState.description')}
			/>
		)
	}

	return (
		<div className="mt-6 overflow-x-auto">
			<table className="min-w-full bg-white border border-gray-300 rounded-lg shadow">
				<thead>
					<tr>
						<th className="py-2 px-4 border-b border-gray-300 text-left w-12">
							<input
								type="checkbox"
								checked={isAllSelected}
								ref={el => {
									if (el) el.indeterminate = isIndeterminate
								}}
								onChange={e => onSelectAll(e.target.checked)}
								className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
							/>
						</th>
						{columns.map(column => (
							<th key={column.key} className="py-2 px-4 border-b border-gray-300 text-left">
								{column.sortable ? (
									<button
										type="button"
										className="flex items-center gap-1 font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
										onClick={() => onSort(column.key)}>
										{column.label}
										{getSortIndicator(column.key, sortColumn, sortDirection)}
									</button>
								) : (
									<span className="font-semibold text-gray-700">{column.label}</span>
								)}
							</th>
						))}
						<th className="py-2 px-4 border-b border-gray-300 text-right w-24">
							<span className="font-semibold text-gray-700">{t('invoices.list.table.actions')}</span>
						</th>
					</tr>
				</thead>

				<tbody>
					{invoicesData.map(invoice => (
						<InvoicesTableRow
							key={invoice._id}
							invoice={invoice}
							systemSettings={systemSettings}
							isSelected={selectedInvoices.has(invoice._id)}
							onSelectInvoice={onSelectInvoice}
							onAssignPlacowka={onAssignPlacowka}
						/>
					))}
				</tbody>
			</table>
		</div>
	)
}
